// @flow
import { connect } from "react-redux";
import WriteJournalDialog from "./view";
import Dialog from "../dialog";
import { hideDialog } from "../state/context/actions";
import { isDialogOpen } from "../state/context/reducer";
import { fetchBlogs } from "../state/blogs/actions";

export default connect(
    state => ({
        open: isDialogOpen(state, "WriteJournal"),
        Dialog
    }),
    dispatch => ({
        onHide: () => dispatch(hideDialog("WriteJournal")),
        onFetchBlogs: () => dispatch(fetchBlogs())
    })
)(WriteJournalDialog);



// WEBPACK FOOTER //
// ./src/write-journal-dialog/index.js